/* lua.js generated code 0.3.0 */

require("clover/gameGuide/GameGuide")
var textureCache = cc.Director.getInstance().getTextureCache()
var Event = require("cocos/framework/components/event")
const GlobalEvent = require("hecore/EventDispatcher").Event
BaseScene = xClass("BaseScene", Event, cc.Scene)
BaseSceneEvent = table([1, "Enter", "BASESCENEEVENT.ENTER"], [1, "Exit", "BASESCENEEVENT.EXIT"])

BaseScene.prototype.ctor = function() {
    cc.Scene.prototype.ctor.call(this)
}

BaseScene.prototype.initScene = function () {
    var self = this
    self.bind(self)
    cc.Scene.prototype.ctor.call(self);
    // function sceneEventHandler(eventType) {
    //     if (eventType === "enter") {
    //         self.onEnter()
    //     } else if (eventType === "enterTransitionFinish") {
    //         self.onEnterTransitionDidFinish()
    //     } else if (eventType === "exit") {
    //         self.onExit()
    //     } else if (eventType === "cleanup") {
    //         self.dispose()
    //     }
    // }
    // self.registerScriptHandler(sceneEventHandler)
    self.onInit()
}
BaseScene.prototype.onInit = function () {
    //cc.log("BaseScene:onInit()")
}
BaseScene.prototype.onEnterTransitionDidFinish = function () {
    cc.Scene.prototype.onEnterTransitionDidFinish.call(this)
    this.runAction(cc.CallFunc.create(function () {
        GameGuide.getInstance().trigger(GameGuideTrigger.kEnterScene)
    }))
}
BaseScene.prototype.onEnter = function () {
    var self = this
    cc.Scene.prototype.onEnter.call(this)
    self.dispatchEvent(table([1, "name", BaseSceneEvent.Enter]))
    GlobalEventDispatcher.getInstance().dispatchEvent(GlobalEvent.new(kGlobalEvents.kOneSceneEnter, { name: self.name }));
}
BaseScene.prototype.onExit = function () {
    var self = this
    cc.Scene.prototype.onExit.call(this)
    GameGuide.getInstance().trigger(GameGuideTrigger.kExitScene)
    self.dispatchEvent(table([1, "name", BaseSceneEvent.Exit]))
}
BaseScene.prototype.onKeyBackClicked = function () {
    //cc.log("BaseScene:onKeyBackClicked()")
}
BaseScene.prototype.onUpdate = function (dt) { }
BaseScene.prototype.dispose = function() {}
BaseScene.prototype.cleanup = function () {
    this.removeAllEventListeners()
    cc.Scene.prototype.cleanup.call(this)

}
BaseScene.prototype.run = function () {
    var self = this
    
    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene) {
        cc.Director.getInstance().runScene(self)
    }
    else{
        cc.Director.getInstance().replaceScene(self)
    }
}
//当场景
BaseScene.prototype.onViewChanged = function () { }